module.exports = __webpack_public_path__ + "static/media/solutions-icon-2.02072e3a.svg";